import { useTranslation } from 'next-i18next';
import React, { useState } from 'react';
import { SpeakerEntry } from '../../../../../../interfaces/pagebuilder';
import VyButton from '../../../../../common/VyButton';
import SpeakerForm from './SpeakerForm';

interface SpeakerCreateButtonProps {
  handleCreateSpeaker: (props: SpeakerEntry) => void;
}
const SpeakerCreateButton = ({ handleCreateSpeaker }: SpeakerCreateButtonProps) => {
  const [isCreateModal, setIsCreateModal] = useState(false);
  const { t } = useTranslation();
  return (
    <div>
      <VyButton isAddButton className="w-full" onClick={() => setIsCreateModal(true)}>
        {t('pagebuilder:entry-add')}
      </VyButton>
      {isCreateModal && <SpeakerForm onSpeakerCreated={handleCreateSpeaker} isModal isModalOpen={isCreateModal} onCloseModal={() => setIsCreateModal(false)} />}
    </div>
  );
};
export default SpeakerCreateButton;
